<template>
  <div>
    <div>
      <div v-if="rowData && rowData.items">
        <el-select
          placeholder="请选择"
          multiple
          popper-class="dropdown-limit-width"
          :disabled="getDisabled()"
          v-model="tempOptionIds"
          @change="multiSelectAnswerBlur($event, rowData)"
        >
          <el-option v-for="(item, idx) in optionItems.items" :label="item.content.text" :key="idx" :value="item.id">
            <template>
              <el-tooltip
                :disabled="item.content.text < 22"
                class="tooltip-style"
                effect="light"
                :content="item.content.text"
                placement="top"
              >
                <span style="max-width: 350px; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{
                  item.content.text
                }}</span>
              </el-tooltip>
            </template>
          </el-option>
        </el-select>
        <div v-for="otherItems in tempOtherItems">
          <span>{{ otherItems.content.text }}</span>
          <el-input
            v-model="getOtherModel(rowData, otherItems).model"
            @input="setOtherVal($event, otherItems)"
            @focus="onFocus($event)"
            @blur="onBlur($event, otherItems)"
            placeholder="请填写其他选项内容"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import '../public/style.css'
import { checkOtherVal, saveArr, getDisabled } from '../public/index.js'

export default {
  name: 'MultipleSelect',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 关联选项
    appendItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    allQuesionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      errorText: '',
      isError: false,
      oldInputVal: ''
    }
  },
  computed: {
    // 下拉选项
    optionItems() {
      let items = this.rowData.questionDetails.issue.items
      if (this.appendItems.length) {
        items = [...this.appendItems, ...items]
      }
      return {
        items
      }
    },
    tempOtherItems() {
      const ids = this.rowData.items.map(i => i.optionId)
      const arr = this.rowData.questionDetails.issue.items.filter(itms => {
        return itms.is_other_item === 1 && ids.includes(itms.id)
      })
      return arr
    },
    getOtherModel() {
      return function (row, item) {
        const optionId = item.id // 当前选项id
        // 从 答案 中 寻找当前的值
        const answerFind = row.items.find(i => i.optionId === optionId)
        const res = (answerFind && answerFind.value) || ''
        return {
          model: res.indexOf('|') !== -1 ? res.split('|')[1] : ''
        }
      }
    },
    tempOptionIds() {
      return this.rowData.items.map(its => {
        return its.optionId
      })
    }
  },
  methods: {
    // 下拉多选
    multiSelectAnswerBlur(selectedVals, row) {
      // 1.更新items，删除，增加
      // 在row.questionDetails.issue.items中查找，返回，过滤掉null
      row.items = this.optionItems.items
        .map(item => {
          if (selectedVals.includes(item.id)) {
            // 更新答案中的value字段，返回答案原始对象里的内容
            let itemAnswerObj = row.items.find(itemAnswer => {
              return itemAnswer.optionId === item.id
            })
            if (itemAnswerObj) {
              // 其他项 不设置
              if (itemAnswerObj.value.indexOf('|') === -1) {
                itemAnswerObj.value = item.content.text
              }
              return itemAnswerObj
            } else {
              return Object.assign({}, itemInitOptions, {
                optionId: item.id,
                value: item.content.text
              })
            }
          } else {
            return null
          }
        })
        .filter(item => {
          return item != null
        })
      // 2.
      // const idIdx = this.updateArr.findIndex((item) => {
      //   return item.questonId === row.questonId
      // })
      const newRow = JSON.parse(JSON.stringify(row))
      delete newRow.tempOptionIds
      // if(idIdx === -1) { //添加
      //   this.updateArr.push(newRow)
      // } else { // 更新
      //   this.updateArr.splice(idIdx, 1, newRow)
      // }
      this.saveArr()
    },
    saveArr,
    // 其他选项 输入的input事件
    setOtherVal(val, item) {
      const optionId = item.id // 当前选项id
      // 从 答案 中 寻找当前的值
      const answerFind = this.rowData.items.find(i => i.optionId === optionId)
      answerFind.value = item.content.text + '|' + val
      // this.saveArr()
    },
    onFocus(e) {
      this.oldInputVal = e.target.value
    },
    onBlur(e, item) {
      let res = this.checkOtherVal(e.target.value, item) // 校验
      this.isError = res
      if (res) {
        this.rowData.items.find(i => i.optionId === item.id).value = item.content.text + '|' + this.oldInputVal
      }
      this.saveArr()
    },
    checkOtherVal,
    getDisabled
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-select__tags-text {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep.el-select .el-tag__close.el-icon-close {
  top: 5px;
}
::v-deep.el-tag.el-tag--info {
  display: flex;
}
</style>
